export default "__VITE_PUBLIC_ASSET__c00ae3f1__"